module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-steuererleichterungen-1760e3225d677cdb90ccf82003c36f48.svg";